import { Plan } from "@/models/Plan";
import { PatientPlan } from "@/models/PatientPlan";
import HasLabel from "@/models/HasLabel";

export interface CombinedPlan {
    plan: Plan;
    patientPlan: PatientPlan;
}

export class CombinedPlan extends HasLabel {
    constructor (combinedPlan: CombinedPlan) {
        super();
        if (combinedPlan) {
            this.plan = Object.assign(new Plan(), combinedPlan.plan);
            this.patientPlan = Object.assign(new PatientPlan(), combinedPlan.patientPlan);
            //Object.assign(this, combinedPlan);
        }
    }

    toString(): string {
        return `${this.plan.toString()} ${this.patientPlan.toString()}`;

    }
}
